import PropTypes from 'prop-types';
import React from 'react';

import { Circle, Container, NumberQty } from './styles';

const IconCircleNumber = ({ qty, onClick }) => (
  <Container>
    <Circle onClick={onClick}>
      <NumberQty>{qty}</NumberQty>
    </Circle>
  </Container>
);

IconCircleNumber.propTypes = {
  qty: PropTypes.number,
  onClick: PropTypes.func.isRequired,
};

IconCircleNumber.defaultProps = {
  qty: 0,
};

export default IconCircleNumber;
